export const SEGMENT_COMPRESSIONS = ["NONE", "GZIP", "SNAPPY", "LZ4", "ZSTD"];
export const SEGMENT_CHECKSUMS = ["NONE", "CRC32", "MD5", "SHA1", "SHA256"];
